module.exports = __webpack_public_path__ + "img/pr-5.97c1e7d6.png";